module.exports = __webpack_public_path__ + "img/icon-6.153b0e27.svg";